<template>
  <form @submit.prevent="submit">
    <PageHeader>
      <div class="heading">
        <h1>
          Site Name
        </h1>
      </div>
    </PageHeader>

    <Field
      label="Site Name"
      @input="$v.resource.name.$touch()"
      @handleChange="handleChange"
      v-model="resource.name"
      :error="nameError"/>

    <hr>

    <PageHeader>
      <div class="heading">
        <h1>
          SEO Settings
        </h1>
      </div>
    </PageHeader>

    <Field
      label="Title Base"
      @input="$v.resource.title_base.$touch()"
      @handleChange="handleChange"
      v-model="resource.title_base"
      helpText="The title base is text that follows the page title. It should contain your brand name and important keywords"
      :error="title_baseError"/>

    <Field
      label="Default Description"
      @input="$v.resource.default_description.$touch()"
      @handleChange="handleChange"
      v-model="resource.default_description"
      helpText="If you do not include a description for your page, search engines will use this text in search results by default"
      :error="default_descriptionError"/>

    <div class="btn-save">
      <btn :class="{'changes-made': changesMade}">Save Changes</btn>
    </div>

    <hr>

    <PageHeader>
      <div class="heading">
        <h1>
          Search Engine Preview
        </h1>
      </div>
    </PageHeader>

    <div class="seo-preview">
      <p class="google-url">{{resource.domain}}</p>
      <h3 class="google-heading">(page name here) | {{resource.title_base}}</h3>
      <p class="google-preview">{{resource.default_description}}</p>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'
import PageHeader from '@/components/PageHeader'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'SiteSeoForm',

  mixins: [form],

  components: {
    Btn,
    PageHeader
  },

  computed: {
    ...errorMessages([
      'name',
      'title_base',
      'default_description'
    ])
  },

  validations: {
    resource: {
      name: {required},
      title_base: {required},
      default_description: {required}
    }
  }
}
</script>

<style lang="sass" scoped>
  .seo-preview
    text-align: left

  .google-heading
    color: #1a0dab
    font-size: 20px
    font-weight: normal
    font-family: arial, sans-serif
    text-transform: none
    margin: 0

    &:hover
      text-decoration: underline
      cursor: pointer

  .google-preview, .google-url
    color: #4d5156
    font-family: arial, sans-serif
    font-size: 14px
    line-height: 1.6

  .google-preview
    margin-top: 5px

  .google-url
    margin-bottom: 5px
    font-size: 10px
</style>
